import axios from 'axios';

import SuccessStoryModel from './success-stories.model.js';

class SuccessStoriesService {
	getOneSuccessStory({ id, language = 'en' }) {
		return axios
			.get(`${
				process.env.REACT_APP_API_ENDPOINT
			}/api/collections/get/successStories?lang=${language}&populate=1&filter[_id]=${id}`)
			.then((res) => {
				if (res.data.entries.length !== 1) {
					return Promise.reject('Story not found');
				}
				return new SuccessStoryModel(res.data.entries[0]);
			})
			.catch(error => Promise.reject(error));
	}

	getListSuccessStories({
		skip = 0,
		limit = 0,
		lang = 'en',
	}) {
		return axios
			.get(`${
				process.env.REACT_APP_API_ENDPOINT
			}/api/collections/get/successStories?lang=${lang}&skip=${skip}&limit=${limit}`)
			.then(res => res.data.entries.map(
				item => new SuccessStoryModel(item),
			))
			.catch(error => Promise.reject(error));
	}
}

export default new SuccessStoriesService();
